import type { BadgeVariant } from './badgeVariants';

// Raw discriminators must never leak as the primary UI label:
// `finding_verdict_delivery` -> "Finding Verdict Delivery".
// Title-casing covers every value in the closed subject-type register, so there
// is no override table to keep in step with it.
export function humanizeSubjectType(subjectType: string): string {
  return subjectType
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// A stable, decorative palette so subject-type chips are visually scannable. New
// types get a consistent color by hashing the discriminator into the palette —
// no per-type CSS. These are scannability colors, not semantic status colors.
const SUBJECT_TYPE_CHIP_PALETTE: readonly BadgeVariant[] = [
  'info',
  'green',
  'orange',
  'warning',
  'success',
  'secondary',
];

function hashString(value: string): number {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) | 0;
  }
  return Math.abs(hash);
}

export function subjectTypeChipVariant(subjectType: string): BadgeVariant {
  const index = hashString(subjectType) % SUBJECT_TYPE_CHIP_PALETTE.length;
  return SUBJECT_TYPE_CHIP_PALETTE[index];
}
